export const saveBlob = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const blobErrorMessage = async (error) => {
  try {
    return JSON.parse(await error.response.data.text()).message;
  } catch {
    return undefined;
  }
};
